'ReceivePurchases'.list({expose: true, icon: "Boxes"})
'Receive Purchases'.title()
'Back'.action({act: 'cancel'})
'Refresh'.action({act: "refresh"})
'View All Receipts'.action({spec: 'ViewPOReceipts.js'})
'PO'.datatype()
'purchaseOrderNumber'.field({key: true, showAsLink: true})
'expectedDeliveryDate'.field()
'supplier'.field({showAsLink: true})
'location'.field({showAsLink: true})
'status'.field()
'costExclTax'.field({caption: "Value (Excl Tax)", showTotal: true})
'costIncTax'.field({caption: "Value (Inc Tax)", showTotal: true})
'Enter Receipt'.action({place: 'row', act: 'add', autoChild: true, spec: 'POReceiptMaint.js'});
'View Receipts'.action({place: 'row', spec: 'ViewPOReceipts.js'});

'ReceivePurchases'.criteria(async function() {
  return {status: {compare: "!=", value: "Received"}}
})

'ReceivePurchases'.defaultSort({field: "expectedDeliveryDate"})

'View Receipts'.availableWhen(po => po.status !== "Awaiting Delivery")

